export default __webpack_public_path__ + "static/media/CarpetBag.a57fbb83.jpg";